import { ChangeEvent, forwardRef, LegacyRef } from "react"
import { Textarea as GoTextarea } from "@gogoro/go-design"
import classnames from "classnames"

import { TextareaProps } from "./TextareaProps"

import styles from "./styles.module.scss"

const Textarea = (
  { name, value, onChange = () => {}, error, disabled, ...restProps }: TextareaProps,
  ref: LegacyRef<HTMLTextAreaElement>,
) => {
  const handleOnChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value
    onChange(value, e)
  }

  return (
    <div className={classnames(styles["container"], { [styles["error"]]: error })} data-testid={`textarea-${name}`}>
      <GoTextarea
        name={name}
        onChange={handleOnChange}
        error={error}
        value={value}
        disabled={disabled}
        ref={ref}
        {...restProps}
      />
    </div>
  )
}

export default forwardRef(Textarea)
